import React, { FC } from 'react'
import LoadingPage from '../qb/Loading/Page'
import { ServiceSend } from '../../types/interface/fsm.interface'
import usePaymentCallback from '../../hooks/shared/usePaymentCallback'

const PaymentHandlingPage: FC<{ send: ServiceSend }> = ({ send }) => {
  usePaymentCallback(send)
  return <LoadingPage />
}

export default PaymentHandlingPage
